import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { DocumentType } from "../../../services/Person Management";

const service = new DocumentType();

const REDUCER_MODULE_NAME = "DOCUMENT TYPE";

const initialState = {
  grid: {
    activos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
    },
    inactivos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
    },
  },
  loading: false,
  error: "",
};

const loadingReducer = (state, _) => {
  return {
    ...state,
    formIsReady: false,
    loading: true,
  };
};

export const grid_activos = createAsyncThunk(
  `GRID_ACTIVOS_${REDUCER_MODULE_NAME}`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 1);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const grid_inactivos = createAsyncThunk(
  `GRID_INACTIVOS_${REDUCER_MODULE_NAME}`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 0);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const changeActive = createAsyncThunk(
  `CHANGE_ACTIVE_${REDUCER_MODULE_NAME}`,
  async ({ id }, { dispatch }) => {
    await service.changeActive(id);

    dispatch(
      grid_activos({
        skip: initialState.grid.activos.skip,
        take: initialState.grid.activos.take,
      }),
    );
    dispatch(
      grid_inactivos({
        skip: initialState.grid.inactivos.skip,
        take: initialState.grid.inactivos.take,
      }),
    );
  },
);

export const slice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: {
    [grid_activos.pending.type]: loadingReducer,
    [grid_inactivos.pending.type]: loadingReducer,

    [grid_activos.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: "",
        grid: {
          ...state.grid,
          activos: {
            ...state.grid.activos,
            page: action.payload.page,
            skip: action.payload.skip,
            take: action.payload.take,
            rows: action.payload.grid_data.rows,
            data: action.payload.grid_data.data,
          },
        },
      };
    },
    [grid_inactivos.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: "",
        grid: {
          ...state.grid,
          inactivos: {
            ...state.grid.inactivos,
            page: action.payload.page,
            skip: action.payload.skip,
            take: action.payload.take,
            rows: action.payload.grid_data.rows,
            data: action.payload.grid_data.data,
          },
        },
      };
    },
  },
});

export const { clean } = slice.actions;

export default slice.reducer;
